// CAPTURAR FORMULÁRIO NATIVO DA SHOPIFY
document.querySelector("#ContactForm")?.addEventListener("submit", async (e) => {
  const form = e.target;

  //const GOOGLE_SHEET_WEBHOOK = "https://script.google.com/macros/s/AKfycbzHzNKyh2OVGBa-IL76ByO5_HHnXjJmEmoII2sDgwZT3oRBPMfawhc1HCmMq8g_CQq5vg/exec";
  const GOOGLE_SHEET_WEBHOOK = "https://script.google.com/macros/s/AKfycbxGYXI_AkwI8nfnMpw-y8EHRU62bsS0mAJQB_zM25OTCw64wxKRrCRtSxhW1OcHVOobuA/exec";

  e.preventDefault();
  e.stopImmediatePropagation();

  const fd = new FormData(form);

  const payload = {
    nome: fd.get("contact[Nome]") || "",
    email: fd.get("contact[email]") || "",
    telefone: fd.get("contact[Telefone]") || "",
    mensagem: fd.get("contact[Mensagem]") || "",
    formulario: "Contato",
    data_envio: new Date().toISOString()
  };

  await fetch(GOOGLE_SHEET_WEBHOOK, {
    method: "POST",
    body: JSON.stringify(payload)
  })
  .then(res => res.json())
  .then(data => console.log(data))
  .catch(err => console.error(err));

  alert("Mensagem enviada com sucesso!");
  form.reset();
});

// CAPTURAR FORMULÁRIO NEWSLETTER DA SHOPIFY
document.querySelector("#FooterNewsletter")?.addEventListener("submit", async (e) => {
  console.log('ENVIOU NEWS');
  const form = e.target;

  //const GOOGLE_SHEET_WEBHOOK = "https://script.google.com/macros/s/AKfycbzHzNKyh2OVGBa-IL76ByO5_HHnXjJmEmoII2sDgwZT3oRBPMfawhc1HCmMq8g_CQq5vg/exec";
  const GOOGLE_SHEET_WEBHOOK = "https://script.google.com/macros/s/AKfycbxGYXI_AkwI8nfnMpw-y8EHRU62bsS0mAJQB_zM25OTCw64wxKRrCRtSxhW1OcHVOobuA/exec";

  e.preventDefault();
  e.stopImmediatePropagation();

  const fd = new FormData(form);

  const payload = {
    nome: fd.get("contact[first_name]") || "",
    email: fd.get("contact[email]") || "",
    formulario: "Newsletter",
    data_envio: new Date().toISOString()
  };

  await fetch(GOOGLE_SHEET_WEBHOOK, {
    method: "POST",
    body: JSON.stringify(payload)
  })
  .then(res => res.json())
  .then(data => console.log(data))
  .catch(err => console.error(err));

  alert("Nesletter cadastrada com sucesso!");
  form.reset();
});

// CAPTURAR FORMULÁRIO DE AVISO DE PRODUTO DA SHOPIFY
document.querySelector("#formListaEspera")?.addEventListener("submit", async (e) => {
  const form = e.target;
  console.log('ENVIOU ESPERA');

  document.getElementById('enviar-aviso-produto').setAttribute('disabled', 'disabled');

  //const GOOGLE_SHEET_WEBHOOK = "https://script.google.com/macros/s/AKfycbzHzNKyh2OVGBa-IL76ByO5_HHnXjJmEmoII2sDgwZT3oRBPMfawhc1HCmMq8g_CQq5vg/exec";
  const GOOGLE_SHEET_WEBHOOK = "https://script.google.com/macros/s/AKfycbxGYXI_AkwI8nfnMpw-y8EHRU62bsS0mAJQB_zM25OTCw64wxKRrCRtSxhW1OcHVOobuA/exec";

  e.preventDefault();
  e.stopImmediatePropagation();

  const fd = new FormData(form);

  const payload = {
    nome: fd.get("name") || "",
    email: fd.get("email") || "",
    telefone: fd.get("phone") || "",
    produto_sku: fd.get("product_sku") || "",
    produto_nome: fd.get("product_nome") || "",
    produto_url: fd.get("product_url") || "",
    formulario: "Aviso Produto",
    data_envio: new Date().toISOString()
  };

  await fetch(GOOGLE_SHEET_WEBHOOK, {
    method: "POST",
    body: JSON.stringify(payload)
  })
  .then(res => res.json())
  .then(data => console.log(data))
  .catch(err => console.error(err));

  alert("Registramos seu interesse no produto!");
  form.reset();

  document.getElementById('enviar-aviso-produto').removeAttribute('disabled');

});

// CAPTURAR FORMULÁRIO DO PRIMEIRO PRODUTO DA SHOPIFY
document.querySelector("#formulario-primeiro-carrinho")?.addEventListener("submit", async function (e) {
  e.preventDefault();
  e.stopImmediatePropagation();

  const form = e.target;
  const submitBtn = document.getElementById('envia-carrinho-abandonado');
  const submitBtnSend = document.querySelector('#formulario-primeiro-carrinho .button-main');
  if (submitBtnSend) submitBtnSend.setAttribute('disabled', 'disabled');
  if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');

  const fd = new FormData(form);
  const GOOGLE_SHEET_WEBHOOK = "https://script.google.com/macros/s/AKfycbxGYXI_AkwI8nfnMpw-y8EHRU62bsS0mAJQB_zM25OTCw64wxKRrCRtSxhW1OcHVOobuA/exec";

  /* ================================
     1️⃣ PEGA O ID DA VARIANTE
  =================================== */
const variantId =
    document.querySelector('form[action="/cart/add"] [name="id"]')?.value ||
    document.querySelector('input[name="id"]')?.value;

  if (!variantId) {
    console.error("ID da variante não encontrado");
    window.location.href = '/cart';
    return;
  }

  // Captura a quantidade selecionada pelo usuário (se não achar, manda 1 por segurança)
  const quantityInput = document.querySelector('form[action="/cart/add"] [name="quantity"]') || 
                        document.querySelector('input[name="quantity"]');
  const quantityValue = quantityInput ? parseInt(quantityInput.value, 10) : 1;

  let cartToken = "";

  try {
    /* ================================
       2️⃣ ADICIONA AO CARRINHO
    =================================== */
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: quantityValue }], 
        sections: "cart-drawer,cart-icon-bubble"
      })
    });

    const cartData = await response.json();

    if (!response.ok) {
      window.location.href = '/cart';
      return;
    }

    /* ================================
       3️⃣ AGORA PEGA TOKEN DEFINITIVO
    =================================== */
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    cartToken = cart.token || cart.cart_token || "";

    console.log("TOKEN FINAL CAPTURADO:", cartToken);

    /* ================================
       4️⃣ ENVIA DADOS + TOKEN
    =================================== */
    fetch(GOOGLE_SHEET_WEBHOOK, {
      method: "POST",
      mode: "no-cors",
      body: JSON.stringify({
        nome: fd.get("nome") || "-",
        telefone: fd.get("telefone") || "-",
        tipo_cliente: fd.get("cliente") || "-",
        card_token: cartToken,
        formulario: "Carrinho Abandonado",
        data_envio: new Date().toISOString()
      })
    });

    /* ================================
       5️⃣ ATUALIZA DRAWER
    =================================== */
    const drawer = document.querySelector('cart-drawer');
    const iconBubble = document.querySelector('#cart-icon-bubble');

    if (drawer && cartData.sections?.['cart-drawer']) {
      const html = new DOMParser().parseFromString(
        cartData.sections['cart-drawer'],
        'text/html'
      );

      const newDrawerContent =
        html.querySelector('#CartDrawer') ||
        html.querySelector('.drawer__inner');

      const currentDrawerContent =
        document.querySelector('#CartDrawer') ||
        document.querySelector('.drawer__inner');

      if (newDrawerContent && currentDrawerContent) {
        currentDrawerContent.innerHTML = newDrawerContent.innerHTML;
      }

      const newItemsCount = html.querySelector('.drawer__header .cart-count-bubble');
      const currentItemsCount = document.querySelector('.drawer__header .cart-count-bubble');

      if (newItemsCount && currentItemsCount) {
        currentItemsCount.innerHTML = newItemsCount.innerHTML;
      }
    }

    if (iconBubble && cartData.sections?.['cart-icon-bubble']) {
      iconBubble.innerHTML = cartData.sections['cart-icon-bubble'];
      iconBubble.classList.remove('hidden');
    }

    fecharModal();

    setTimeout(() => {
      drawer?.classList.remove('is-empty');

      const cartIcon =
        document.querySelector('#cart-icon-bubble') ||
        document.querySelector('.header__icon--cart');

      if (cartIcon) cartIcon.click();

      drawer?.classList.add('active');
    }, 150);

  } catch (err) {
    console.error("Erro no fluxo:", err);
    window.location.href = '/cart';
  }

  form.reset();
  if (submitBtn) submitBtn.removeAttribute('disabled');
});


async function formularioCarrinho() {
  const popupform = document.querySelector('.popup-client-infos');
  if(popupform) popupform.classList.add('open');
}

async function fecharModal(){
  const popupform = document.querySelector('.popup-client-infos');
  if(popupform) popupform.classList.remove('open');
}

async function enviaTokenCarrinho(){
  const GOOGLE_SHEET_WEBHOOK = "https://script.google.com/macros/s/AKfycbxGYXI_AkwI8nfnMpw-y8EHRU62bsS0mAJQB_zM25OTCw64wxKRrCRtSxhW1OcHVOobuA/exec";
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const payload = { card_token: cart.token, formulario: "Carrinho Token" };
      fetch(GOOGLE_SHEET_WEBHOOK, { method: "POST", mode: "no-cors", body: JSON.stringify(payload) });
    });  
}